module.exports = __webpack_public_path__ + "static/media/choker.3f31b095.png";